.panel {
	height: var(--disclosure-panel-height);
	overflow: hidden;
	transition: height 220ms ease;
	/* overflow: hidden (needed for the height animation) also clips horizontally,
	   cutting the 2px focus outline off edge-aligned fields; the inline padding
	   gives it room, and the matching negative margin keeps content aligned. */
	margin-inline: -4px;
	padding-inline: 4px;
}

.trigger {
	display: inline-flex;
	align-items: center;
	gap: 8px;
	height: 32px;
	padding: 0;
	background: none;
	border: none;
	cursor: pointer;
	color: var(--content-primary);
}

.triggerIcon {
	transform: rotate(-90deg);
	transition: transform 150ms ease;
}

.triggerIconExpanded {
	transform: rotate(0deg);
}
